import {
  Component,
  OnInit,
  ViewEncapsulation,
  Input,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";

import { ZoneComponent } from "@/shared-module/components";
import { PlaceHolderDatasource } from "@/shared-module/models";

@Component({
  selector: "app-placeholder",
  templateUrl: "placeholder.component.html",
  encapsulation: ViewEncapsulation.None,
})
export class PlaceHolderComponent implements ZoneComponent, OnInit {
  @ViewChild("template", { static: true }) template;
  @Input() data: PlaceHolderDatasource;
  @Input() width: number;
  @Input() needpaddingLeft: boolean;
  @Input() isZoom: boolean;

  constructor(
    private viewContainerRef: ViewContainerRef,
  ) {}


  ngOnInit() {
    this.viewContainerRef.createEmbeddedView(this.template);
  }
}
